import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
export const useFeatureFlags = ()=>useStore(selectors.ff.featureFlagsData);
